import AdvancedAssign from './AdvancedAssign/AdvancedAssign';
import { types } from './types';
/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRenbder - variable render
 * @param       showAlert -  show alert
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function Actions(action, showAlert, variables, setOpenVariable, recorder, variableRender) {
    switch (action.actionName) {
        case types.ADVANCEDASSIGN: return <AdvancedAssign action={action} showAlert={showAlert} variables={variables} variableRender={variableRender} setOpenVariable={setOpenVariable} recorder={recorder} />;
        default: break;
    }
}
export default Actions;